module.exports = __webpack_public_path__ + "media/images/icons/email-63445debfcf14bc60ec89009c99cbc02.svg";